<template>
  <div>
    <div class="d-flex justify-content-between ts-mb-3">
      <h1 class="page-header ts-mb-0">{{ $t('bankV2.createTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('bankV2.breadcrumb'), href: '/v2/payment/banks' },
          { text: $t('bankV2.createTitle'), active: true }
        ]"
      />
    </div>
    <bank-form mode="create" />
  </div>
</template>

<script>
import BankForm from '../components/BankForm.vue'

export default {
  name: 'BankV2Create',
  components: { BankForm }
}
</script>
